import { Icon, Tooltip } from '@nazka/nazka.mapframe.components';
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons';
import { faCircleInfo } from '@fortawesome/pro-solid-svg-icons';

import './info-icon.css';

function InfoIcon({ tooltip, id, className, size = '16px', color, type, ...props }) {
  return (
    <Tooltip id={id} tooltip={tooltip} className={className} opacity={1} {...props}>
      <Icon
        icon={type === 'filled' ? faCircleInfo : faInfoCircle}
        size={size}
        color={color}
        rootElProps={{ 'data-tooltip-id': id }}
      />
    </Tooltip>
  );
}

export default InfoIcon;
